export default "__VITE_ASSET__AxW2j3vw__"